import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  ExistingWithTree: {
    '&__expand-bar': {
      '&__arrow': {
        color: theme.palette.black,
        marginLeft: 'auto',
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '&--open': {
          transform: 'rotate(180deg)',
        },
      },
    },
  },
}));
